export const buildingDescription = (data?: Api.Building) => {
	if (
		data === null ||
		typeof data === 'undefined' ||
		!Object.prototype.hasOwnProperty.call(data, 'address')
	) {
		return ''
	}
	return `${data.address.street} ${data.address.street.endsWith(',') ? '' : ','} ${
		data.address.zip
	} ${data.address.city}`
}
